import { CustomElementConstructor } from '../custom-elements/create-custom-element'
import { RegisterCustomElementOptions } from '../custom-elements/register-custom-element-factory'
import { registerActionElement } from './action/action.component'
import { registerAlertElement } from './alert/alert.component'
import { registerCardHeaderElement } from './card/card-header/card-header.component'
import { registerCardElement } from './card/card.component'
import { registerCheckboxListElement } from './checkbox-list/checkbox-list.component'
import { registerCheckboxElement } from './checkbox/checkbox.component'
import { registerDomModifierElement } from './dom-modifier/dom-modifier.component'
import { registerDownloadElement } from './download/download.component'
import { registerDropdownElement } from './dropdown/dropdown.component'
import { registerFormElement } from './form/form.component'
import { registerGaugeElement } from './gauge/gauge.component'
import { registerInputElement } from './input/input.component'
import { registerLazyLinkElement } from './lazy-link/lazy-link.component'
import { registerMapElement } from './map/map.component'
import { registerPaginationElement } from './pagination/pagination.component'
import { registerPrintEventButtonElement } from './print-event-button/print-event-button.component'
import { registerRedirectElement } from './redirect/redirect.component'
import { registerSelectSetElement } from './select-set/select-set.component'
import { registerSelectElement } from './select/select.component'
import { registerSetItemElement } from './set-item/set-item.component'
import { registerTabSetElement } from './tab-set/tab-set.component'
import { registerTextareaElement } from './textarea/textarea.component'
import { registerToastElement } from './toast/toast.component'

/**
 * Register all custom elements in the library.
 *
 * @public
 *
 * @param configs A selection of options to configure how the custom elements are registered
 *
 * @returns       A collection of constructors for the registered custom elements
 */
export async function registerElements(configs?: RegisterCustomElementOptions): Promise<Array<CustomElementConstructor<unknown>>> {
  return await Promise.all([
    registerActionElement(configs),
    registerAlertElement(configs),
    registerCardHeaderElement(configs),
    registerCardElement(configs),
    registerCheckboxElement(configs),
    registerCheckboxListElement(configs),
    registerDomModifierElement(configs),
    registerDownloadElement(configs),
    registerDropdownElement(configs),
    registerFormElement(configs),
    registerGaugeElement(configs),
    registerInputElement(configs),
    registerLazyLinkElement(configs),
    registerMapElement(configs),
    registerPaginationElement(configs),
    registerPrintEventButtonElement(configs),
    registerRedirectElement(configs),
    registerSelectElement(configs),
    registerSelectSetElement(configs),
    registerSetItemElement(configs),
    registerTabSetElement(configs),
    registerTextareaElement(configs),
    registerToastElement(configs)
  ])
}
